import React from "react";
import "./Section2.css";
import Section2Image from "../../../../../assets/images/payrollsrsec1-img1.png";
import Section2Dots from "../../../../../assets/images/aboutus-dots.png";
import Triangle from "../../../../../assets/images/skyblue-triangle.png";
const Section2 = () => {
  return (
    <div className="aliensrsec2_section">
      <img src={Section2Dots} alt="" className="aliensrsec2__section_dots" />

      <div className="aliensrsec2__section_left">
        <img src={Section2Image} alt="" className="aliensrsec2__section_img" />
      </div>
      <div className="aliensrsec2__section_right">
        <img src={Triangle} alt="" className="aliensrsec2__section_triangle" />
        <div className="aliensrsec2__secleft_heading">Tax Treaty</div>
        <div className="aliensrsec2__secleft_description">
          <p>
            The United States government has a number of income tax treaties
            with foreign countries. Tax treaties can often reduce or eliminate
            U.S. tax on various types of income of a non-resident alien,
            including interest, dividends, royalties, capital gains and
            pensions. Beneficial provisions are usually not available with
            respect to income from the sale of U.S. real estate. It is important
            to note that each individual income tax treaty should be reviewed
            and analysed to determine whether specific types of income are
            exempt from U.S. tax or taxed at a reduced rate, and what conditions
            apply to such exemptions and reductions.
          </p>
          <p>
            It should be noted that in order to utilize a treaty provision,
            taxpayers must include IRS Form 8833 (Treaty-Based Return Position
            Disclosure) with their expat tax returns – Form 1040NR or 1040NR-EZ
            – and disclose their position.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Section2;
